export enum CHECKOUT_CART_TRANSITIONS {
  START_CHECKOUT = 'START_CHECKOUT',
  USER_READY = 'USER_READY',
  SYNC_ERROR = 'SYNC_ERROR',
}
